export default {
    tinySizeLookup: {
        Small: "20",
        Medium: "35",
        Large: "50",
    },
    mobileSizeLookup: {
        Small: "20",
        Medium: "40",
        Large: "60",
    },
    desktopSizeLookup: {
        Small: "40",
        Medium: "60",
        Large: "80",
    }
}